import { NgModule } from '@angular/core';
import { PrizmInputOpacityDirective } from './input-opacity.directive';

@NgModule({
  declarations: [PrizmInputOpacityDirective],
  exports: [PrizmInputOpacityDirective],
})
export class PrizmInputOpacityModule {}
